import type { Aircraft, Lesson, Profile } from "./types";

export const profileById = (profiles: Profile[], id: string | null): Profile | undefined =>
  id ? profiles.find((p) => p.id === id) : undefined;

export const aircraftById = (aircraft: Aircraft[], id: string | null): Aircraft | undefined =>
  id ? aircraft.find((a) => a.id === id) : undefined;

export const lessonById = (lessons: Lesson[], id: string | null): Lesson | undefined =>
  id ? lessons.find((l) => l.id === id) : undefined;
